import { apiRequest } from "./client";

export type KnowledgeFile = {
  id: number;
  filename: string;
  sha256: string;
  size_bytes: number;
  mime: string | null;
  uploaded_by: number | null;
  uploaded_at: string;
  indexed_at: string | null;
  point_count: number;
};

export type KnowledgeFileListResponse = { items: KnowledgeFile[] };

export type KnowledgeUploadResponse = {
  file: KnowledgeFile;
  created: boolean;
};

export function listKnowledgeFiles(tabId: string) {
  return apiRequest<KnowledgeFileListResponse>(`/admin/tabs/${tabId}/knowledge/files`);
}

export async function uploadKnowledgeFile(tabId: string, file: File) {
  const fd = new FormData();
  fd.append("file", file);
  return apiRequest<KnowledgeUploadResponse>(`/admin/tabs/${tabId}/knowledge/files`, {
    method: "POST",
    formData: fd,
  });
}

export function deleteKnowledgeFile(tabId: string, fileId: number) {
  return apiRequest<{ ok: boolean }>(`/admin/tabs/${tabId}/knowledge/files/${fileId}`, {
    method: "DELETE",
  });
}

export async function replaceKnowledgeFile(tabId: string, fileId: number, file: File) {
  const fd = new FormData();
  fd.append("file", file);
  return apiRequest<KnowledgeUploadResponse>(
    `/admin/tabs/${tabId}/knowledge/files/${fileId}/replace`,
    { method: "POST", formData: fd },
  );
}
